<template>
  <div :class="{ 'ga-confirm-stack-top': stackOnTop }">
    <b-modal
      size="md"
      centered
      hide-footer
      hide-header
      body-class="p-0"
      :static="stackOnTop"
      @hidden="emitHidePopup"
      v-model="showModal">
      <div class="w-100">
        <!-- BODY -->
        <div class="p-4 text-center">
          <p class="mb-3 heading-6-1">{{ title }}</p>
          <p class="mb-0 body-2-2" v-html="subtitle"></p>
        </div>

        <!-- BUTTON -->
        <div class="w-100 p-3 bg-light">
          <div class="row no-gutters">
            <div class="col-6">
              <div class="pr-2">
                <button @click="emitHidePopup" class="g-btn g-btn-md g-btn-white rounded w-100 border-form d-flex align-items-center justify-content-center py-3">
                  <div class="lh-1" style="height: 16px;">
                    <svg class="mr-4" height="12" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.8 2.21L13.39 0.800003L7.8 6.39L2.21 0.800003L0.800003 2.21L6.39 7.8L0.800003 13.39L2.21 14.8L7.8 9.21L13.39 14.8L14.8 13.39L9.21 7.8L14.8 2.21Z" fill="#222222"/>
                    </svg>
                  </div>
                  <span class="lh-1">Cancel</span>
                </button>
              </div>
            </div>
            <div class="col-6">
              <div class="pl-2">
                <button @click="applyClicked" class="g-btn g-btn-md g-btn-danger rounded w-100 border-danger d-flex align-items-center justify-content-center py-3">
                  <svg class="mr-4" height="16" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.96216 14.3925C4.67027 14.3925 4.48316 14.2204 4.46819 13.936L4.24366 5.69563C4.23617 5.41871 4.42328 5.23908 4.72266 5.23908C4.99958 5.23908 5.19418 5.41123 5.20166 5.68815L5.44116 13.936C5.44865 14.2129 5.25405 14.3925 4.96216 14.3925ZM7.24494 14.3925C6.953 14.3925 6.75093 14.2129 6.75093 13.936V5.69563C6.75093 5.41871 6.953 5.23908 7.24494 5.23908C7.53681 5.23908 7.74636 5.41871 7.74636 5.69563V13.936C7.74636 14.2129 7.53681 14.3925 7.24494 14.3925ZM9.53514 14.3925C9.24327 14.3925 9.04867 14.2129 9.05614 13.936L9.28817 5.69563C9.29564 5.41123 9.49024 5.23908 9.76717 5.23908C10.0665 5.23908 10.2536 5.41871 10.2462 5.69563L10.0216 13.936C10.0067 14.2204 9.81954 14.3925 9.53514 14.3925ZM3.95925 3.42037H5.14927V1.81871C5.14927 1.3921 5.44865 1.11517 5.89772 1.11517H8.57714C9.02619 1.11517 9.32559 1.3921 9.32559 1.81871V3.42037H10.5156V1.74387C10.5156 0.658628 9.81207 0 8.65946 0H5.81538C4.66278 0 3.95925 0.658628 3.95925 1.74387V3.42037ZM0.56133 4.01913H13.936C14.2428 4.01913 14.4898 3.75717 14.4898 3.45031C14.4898 3.14345 14.2428 2.88898 13.936 2.88898H0.56133C0.261954 2.88898 0 3.14345 0 3.45031C0 3.76466 0.261954 4.01913 0.56133 4.01913ZM3.81705 16.6678H10.6803C11.7505 16.6678 12.469 15.9717 12.5214 14.9014L13.0453 3.86196H1.44449L1.97588 14.909C2.02827 15.9792 2.73181 16.6678 3.81705 16.6678Z" fill="#fff"/>
                  </svg>
                  <span class="lh-1">Remove</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
  
<script>
  export default {
    props:{
      show:{
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ""
      },
      subtitle: {
        type: String,
        default: ""
      },
      // opt-in: keeps the dialog above this app's fixed overlays (map room
      // popup, room type detail). Off by default because it renders the dialog
      // inline instead of at <body>, which only works where the caller places
      // this component at page level -- see the style block below.
      stackOnTop: {
        type: Boolean,
        default: false
      },
    },
    data(){
      return{
        showModal: false
      }
    },
    watch: {
      show(){
        this.showModal = this.show
      }
    },
    methods:{
      emitHidePopup(){
        this.$emit('hide', {show: false, title: '', subtitle: ''})
      },
      applyClicked(){
        this.$emit('apply')
      }
    }
  }
</script>

<style scoped>
/* b-modal wraps its dialog and backdrop in an unclassed outer <div> that it
   pins at `position: absolute; z-index: <base>` inline (modal-manager reads the
   base from .modal-backdrop, so 1040). That outer div is a stacking context, so
   nothing set on .modal inside it can escape 1040 -- below the BE map popup's
   own dim/panel (1041-1043) and the warning lands behind the popup that raised
   it. Raising this root instead puts b-modal's whole 1040 context inside a
   1100 one, which is why it has to sit here and not on the dialog.

   Needs `static` to work: portaled to <body> the dialog leaves this root
   entirely. Hence the opt-in -- inline rendering is only safe where the caller
   places this component at page level. */
.ga-confirm-stack-top {
  position: relative;
  z-index: 1100;
}
</style>



// WEBPACK FOOTER //
// src/components/general/popupConfirmation.vue